import { CareerBackInterfacesDTOBlogBlogPreviewDto } from "../../../../shared/ApiContract/data-contracts";
import { useGetPostImageQuery } from "../../api/blogApi";

export const BlogImage = ({
    previewImageId,
    className,
    alt,
}: {
    previewImageId: CareerBackInterfacesDTOBlogBlogPreviewDto["previewImageId"];
    className?: string;
    alt?: string | null;
}) => {
    const { data } = useGetPostImageQuery(previewImageId as string);

    return <img src={data} className={className} alt={alt ?? ""} />;
};

export default BlogImage;
